export default {
    'general': {
        'versioning': 'Versioning',
        'dashboard': 'Dashboard',
        'email': 'Email',
        'username': 'Username',
        'name': 'Name',
        'password': 'Password',
        'actions': 'Actions',
        'login': 'Login',
        'logout': 'Logout',
        'no_results': 'No results',
        'success': 'Success',
        'warning': 'Warning',
        'remember_me': 'Remember me',
        'error': 'Error',
        'edit': 'Edit',
        'details': 'Details',
        'add': 'Add',
        'delete': 'Delete',
        'yes': 'Yes',
        'no': 'No',
        'cancel': 'Cancel',
        'back': 'Back',
        'image': 'Image',
        'filters': 'Filters',
        'remove_filters': 'Remove filters',
        'default': 'Default',
        'save': 'Save',
        'key': 'Key',
        'distribution_zone': 'Distribution zone',
        'preview': 'Preview',
        'icon': 'Icon',
        'last_edited': 'Last edited',
        'unknown': 'Unknown',
        'latest_version': 'Latest version',
        'taxpayer': 'Taxpayer',
        'country': 'Country',
        'date_at': 'at',
        'drag_and_drop_files_to_upload': 'Drag and drop files to upload',
        'export': 'Export',
        'options': 'Options',
        'download': 'Download'
    },
    'warning': {
        'file_preview_not_available': 'Preview not available for this file type.'
    },
    'errors': {
        'generic_error': 'There was an error',
        'login': 'There was an error logging in',
        'logout': 'There was an error logging out',
        'incorrect_password': 'The old password is incorrect',
        'invalid_data': 'Invalid data received',
        'not_found': 'Data not found',
        'user_exist': 'User with this email already exists',
        'load_data': 'There was an error loading data',
        'on_upload_image': 'There was an error uploading images',
        'on_upload_file': 'There was an error uploading files',
        'on_publish': 'There was an error while publishing',
        'on_approve': 'There was an error while approving',
        'on_download': 'There was an error while downloading file',
        'on_add': 'There was an error adding',
        'on_edit': 'There was an error editing',
        'on_delete': 'There was an error deleting',
        'on_sort': 'There was an error sorting',
        'unauthorized': 'Unauthorized',
        'user_does_not_exist': 'User does not exists',
        'country_not_found': 'Country not found',
        'country_not_specified': 'Country not specified',
        'tax_number_not_found': 'Tax number not found',
        'company_with_vat_number_exists': 'Company with this tax number already exists',
        'username_exists': 'This username already exists. Please use different username.',
        'email_exists': 'This email already exists. Please use different email.',
        'failed_to_insert': 'Failed to insert',
        'file_to_big': 'File is to big',
        'missing_roles': 'Missing roles',
        'no_roles_selected': 'User must have at least one role selected',
        'fetching_data': 'Error fetching data',
        'deleting_default_data': 'Error deleting default data',
        'data_already_exists': 'Data already exists',
        'unable_to_retrieve_extension': 'Unable to retrieve extension',
        'role_exists': 'Role exists',
        'role_does_not_exist': 'role does not exists',
        'no_access': 'No access'
    },
    'success': {
        'on_add': 'Successfully added',
        'on_edit': 'Successfully edited',
        'on_delete': 'Successfully deleted',
        'on_update': 'Successfully updated',
        'on_remove': 'Successfully removed',
        'on_publish': 'Successfully published',
        'on_approve': 'Successfully approved',
        'on_sort': 'Successfully sorted',
        'on_change_password': 'The password has been successfully changed',
        'channel_package_activated': 'Channel package successfully activated',
        'channel_package_deactivated': 'Channel package successfully deactivated'
    },
    'confirmations': {
        'general': 'Are you sure you want to proceed?',
        'header': 'Are you sure',
        'delete_row': 'Are you sure you want to delete',
        'deactivate_row': 'Are you sure you want to deactivate',
        'publish': 'Are you sure you want to publish on',
        'approve': 'Are you sure you want to approve'
    },
    'table': {
        'no_data': 'No data to display',
        'press_enter_search': 'Press enter to search',
        'search': 'Search by',
        'select_option': 'Select option',
        'select_date': 'Select date',
        'select_range': 'Select range',
        'of': 'of'
    },
    'file': {
        'drag_and_drop': 'Drag and drop files to here to upload.'
    },
    'comment': {
        'reply': 'Reply',
        'replies': 'Replies',
        'show_more_replies': 'Show more replies',
        'show_replies': 'Show replies',
        'hide_replies': 'Hide replies',
        'attachments': 'Attachments',
        'comment': 'Comment',
        'comments': 'Comments',
        'edited': 'edited',
        'deleted': 'Comment deleted',
        'deleted_at': 'Deleted',
        'delete': 'comment',
        'attachment': 'Attachment',
        'add_comment': 'Add a comment',
        'add_comment_text': 'Add a comment (use {\'@\'} to mention)'
    },
    'language': {
        'slovenian': 'Slovenian',
        'english': 'English',
        'croatian': 'Croatian'
    },
    'signature': {
        'signature': 'Signature',
        'sign': 'Sign',
        'cancel': 'Cancel',
        'clear': 'Clear'
    },
    'lead': {
        'lead': 'Lead',
        'leads': 'Leads',
        'add': 'Add lead',
        'priority': 'Priority',
        'save': 'Save',
        'project_milestones': 'Project Milestones',
        'hide_devices_page': 'Do not show the devices page',
        'devices_page_shown': 'Devices page shown',
        'company': {
            'add': 'Add company',
            'edit': 'Edit company data',
            'does_not_exist': 'Company does not exist',
            'select': 'Company select',
            'company': 'Company'
        },
        'active_seller': {
            'edit': 'Edit active seller'
        },
        'maintenance_worker': {
            'edit': 'Edit maintenance worker'
        },
        'contact': {
            'add': 'Add contact',
            'select': 'Contact select',
            'info': 'Contact info',
            'contact': 'Contact',
            'contact_information': 'Contact Information'
        },
        'business_unit': {
            'business_unit': 'Business unit',
            'business_units': 'Business units',
            'add_new': 'Add new business unit',
            'created': 'Created',
            'last_edited': 'Last edited',
            'select': 'Select',
            'business_unit_select': 'Business unit select',
            'edit': 'Edit',
            'edit_business_unit': 'Edit business unit',
            'remove': 'Remove',
            'status': 'STATUS',
            'name': 'Name',
            'address': 'Address',
            'add': 'Add business unit',
            'primary_activity': 'Primary activity',
            'view': 'View'
        },
        'status': {
            'status': 'Lead status',
            'draft': 'Draft',
            'offer_sent': 'Offer sent',
            'data_retrieval': 'Data retrieval',
            'data_entry': 'Data entry',
            'installation': 'Installation',
            'rejected': 'Rejected',
            'additional_requirements': 'Additional requirements',
            'completed': 'Completed',
            'rejection_reason': 'Rejection reason',
            'reject': 'Reject',
            'empty': 'EMPTY',
            'started': 'STARTED',
            'finished': 'FINISHED'
        },
        'tasks': {
            'contact_request': 'Contact request',
            'presentation_to_client': 'Presentation to client',
            'requirements_analysis': 'Requirements analysis',
            'offer_and_contract_prepare': 'Offer and contract prepare',
            'offer_and_contract_presentation': 'Offer and contract presentation',
            'estimated_finish_date': 'Estimated finish date',
            'estimated_finish': 'Estimated finish',
            'finished': 'Finished',
            'not_finished': 'Not finished',
            'tasks': 'Tasks',
            'mark_as_finished': 'Mark as finished',
            'mark_as_not_finished': 'Mark as not finished'
        },
        'software_offer': {
            'software_offer': 'Software offer',
            'licence': 'Licence',
            'discount': 'Discount',
            'desktop_devices': 'Desktop devices',
            'mobile_devices': 'Mobile devices',
            'number_of_products': 'Number of products',
            'number_of_ingredients': 'Number of ingredients',
            'payment_type': 'Payment type',
            'payment_month': 'Payment month',
            'payment_frequency': 'Payment frequency',
            'wolt_integration_enabled': 'Wolt integration enabled',
            'return_packaging_integration_enabled': 'Return packaging integration enabled',
            'installation_option': 'Installation option',
            'installation_price': 'Installation price',
            'option': {
                'according_to_price_list': 'According to price list',
                'discount_100_percentages': '100% discount',
                'hide_table_on_offer': 'Hide table on offer',
                'custom_price': 'Custom price'
            },
            'software': 'Software',
            'imprion_pos': 'Imprion POS'
        },
        'hardware_offer': {
            'hardware': 'Hardware',
            'client_has_all_hardware': 'Client has all hardware',
            'hardware_offer': 'Hardware offer',
            'hardware_offers': 'Hardware offers',
            'pos_hardware': 'POS hardware',
            'is_custom_hardware': 'Is custom hardware',
            'pos_hardware_custom': 'POS hardware custom',
            'quantity': 'Quantity',
            'price': 'Price',
            'price_per_item': 'Price per item',
            'price_with_vat': 'Price with VAT',
            'price_with_discount': 'Price with discount',
            'total_price': 'Total price',
            'discount': 'Discount',
            'add': 'Add',
            'edit': 'Edit',
            'cancel': 'Cancel',
            'vat': 'VAT'
        },
        'payment_gateway_status': {
            'payment_gateway_status': 'Payment gateway status',
            'using_card_payments': 'Using card payments',
            'current_card_payment_provider': 'Current card payment provider',
            'custom_card_system': 'Custom card system',
            'want_to_use_card_system': 'Want to use card system',
            'provider': 'Provider'
        },
        'connection_schedule': {
            'connection_schedule': 'Connection schedule',
            'connection_type': 'When do you want to connect',
            'connection_date': 'Connection date',
            'connection': 'Connection'
        },
        'additional_requests': {
            'additional_requests': 'Additional requests',
            'additional_request': 'Additional request',
            'request': 'Request',
            'priority': 'Priority',
            'add': 'Add',
            'edit': 'Edit',
            'cancel': 'Cancel'
        },
        'network_infrastructure': {
            'network_infrastructure': 'Network infrastructure',
            'is_wifi_setup': 'Is WiFi setup',
            'business_unit_wifi_covered': 'Business unit WiFi covered',
            'is_wifi_stable': 'Is WiFi stable',
            'multiple_ap_in_business_unit': 'Multiple AP in business unit',
            'multiple_ap': 'Multiple AP',
            'ap_has_roaming': 'AP has roaming',
            'ap_manufacturer': 'AP manufacturer',
            'ap_manufacturer_custom': 'Custom AP manufacturer',
            'network_manager_type': 'Network manager type',
            'network_manager': 'Network manager',
            'network_manager_name': 'Network manager name',
            'can_devices_sync': 'Can devices sync'
        },
        'priority_value': {
            'low': 'Low',
            'medium': 'Medium',
            'high': 'High',
            'urgent': 'Urgent',
            'critical': 'Critical'
        },
        'sale': 'Sale',
        'generating_quote': 'Generating quote',
        'printout_of_entered_data': 'Printout of entered data',
        'create_new_company': 'Create new company'
    },
    'editor': {
        'heading': 'Heading',
        'subheading': 'Subheading',
        'subheading_3': 'Subheading 3',
        'base': 'Base',
        'bold': 'Bold',
        'italic': 'Italic',
        'underline': 'Underline',
        'left_align': 'Left',
        'center_align': 'Center',
        'right_align': 'Right',
        'justify_align': 'Justify',
        'ordered_list': 'Ordered list',
        'bullet_list': 'Bullet list',
        'small': 'Small',
        'normal': 'Normal',
        'large': 'Large',
        'huge': 'Huge',
        'link': 'Link'
    },
    'months': {
        'january': 'January',
        'february': 'February',
        'march': 'March',
        'april': 'April',
        'may': 'May',
        'june': 'June',
        'july': 'July',
        'august': 'August',
        'september': 'September',
        'october': 'October',
        'november': 'November',
        'december': 'December'
    },
    'licences': {
        'essential': 'Essential',
        'standard': 'Standard',
        'premium': 'Premium'
    },
    'timelee': {
        'without': 'Without',
        'basic': 'Basic',
        'pro': 'Pro',
        'discount_on_timelee': 'Discount on timelee'
    },
    'payment_frequencies': {
        'monthly': 'Monthly',
        'instalment_plan': 'Instalment plan',
        'yearly': 'Yearly'
    },
    'payment_interval': {
        'payment_interval': 'Payment interval',
        'three_months': 'Every 3 months',
        'four_months': 'Every 4 months',
        'six_months': 'Every 6 months'
    },
    'card_payment_providers': {
        'besteron': 'Besteron',
        'hobex': 'Hobex',
        'wordline': 'Wordline',
        'other': 'Other'
    },
    'connection_types': {
        'asap': 'ASAP',
        'no_preference': 'No preference',
        'fixed_date': 'Fixed date'
    },
    'ap_roaming_types': {
        'yes': 'Yes',
        'no': 'No',
        'unknown': 'Unknown'
    },
    'ap_manufactures': {
        'ubiquiti': 'Ubiquiti',
        'tp_link': 'TP link',
        'tenda': 'Tenda',
        'mikrotik': 'Mikrotik',
        'asus': 'Asus',
        'zyxel': 'Zyxel',
        'd_link': 'D link',
        'cisco': 'Cisco',
        'huawei': 'Huawei',
        'ruijie_reyeea': 'Ruijie-ReyeeA',
        'aruba': 'Aruba',
        'ruckus': 'Ruckus',
        'xirrus': 'Xirrus',
        'cambium': 'Cambium',
        'other': 'Other'
    },
    'network_manager_types': {
        'inner': 'Inner',
        'outer': 'Outer'
    },
    'primary_activities': {
        'restaurant': 'Restaurant',
        'food_truck': 'Food truck',
        'hairdresser': 'Hairdresser',
        'beauty_salon': 'Beauty salon',
        'other_service_activity': 'Other service activity',
        'other': 'Other'
    },
    'company': {
        'company': 'Company | Companies',
        'company_that_not_exists': 'Company that doesn\'t exist | Companies that don\'t exist',
        'add': 'Add company',
        'edit': 'Edit company',
        'official_name': 'Official name',
        'alias': 'Alias',
        'country': 'Country',
        'country_name': 'Country name',
        'country_code': 'Country code',
        'tax_number': 'TAX number',
        'address': 'Address',
        'is_tax_payer': 'Is TAX payer',
        'contact': {
            'title': 'Company contact | Company contacts',
            'add': 'Add company contact',
            'edit': 'Edit company contact',
            'first_name': 'First name',
            'last_name': 'Last name',
            'email': 'Email',
            'phone_number': 'Phone number',
            'company_role': 'Company role'
        }
    },
    'business_unit': {
        'business_unit': 'Business unit | Business units',
        'add': 'Add business unit',
        'edit': 'Edit business unit',
        'primary_activity': 'Primary activity',
        'movable': 'Movable',
        'is_movable': 'Is movable',
        'activity': {
            'catering_establishment': 'Catering establishment',
            'food_truck': 'Food truck',
            'hair_salon': 'Hair salon',
            'beauty_salon': 'Beauty salon',
            'other_service_activity': 'Other service activity',
            'other': 'Other'
        }
    },
    'profile': {
        'profile': 'Profile',
        'edit_profile': 'Edit profile',
        'old_password': 'Old password',
        'new_password': 'New password',
        'confirm_password': 'Confirm password',
        'change_password_text': 'If password field is empty, password will not be changed.',
        'change_password': 'Change password'
    },
    'seller': {
        'seller': 'Seller | Sellers',
        'active_seller': 'Active seller',
        'maintenance_worker': 'Active maintenance worker',
        'add': 'Add seller',
        'edit': 'Edit edit',
        'first_name': 'First name',
        'last_name': 'Last name',
        'email': 'Email',
        'phone_number': 'Phone number',
        'language': 'Language',
        'password': 'Password',
        'change_password': 'Change password',
        'new_password': 'New password',
        'confirm_password': 'Confirm password',
        'role': {
            'role': 'Role | Roles',
            'view_all_leads': 'View all leads',
            'reassign_leads': 'Reassign leads',
            'remove_leads': 'Remove leads',
            'manage_users': 'Manage users'
        }
    },
    'current_software': {
        'current_software': 'Current software | Current software',
        'current_software_custom': 'Custom current software'
    },
    'lead_source': {
        'lead_source': 'Lead source | Lead sources',
        'lead_source_custom': 'Custom lead source'
    },
    'besteron': {
        'payment_data': 'Besteron payment data',
        'company_name': 'Company name',
        'activity': 'Activity',
        'activity_suggestion': '(restaurant, shop,...)',
        'activity_custom': 'Enter activity',
        'pos_terminal_location': 'POS terminal location',
        'pos_terminal_location_suggestion': 'address',
        'location_name': 'Location name',
        'location_name_suggestion': 'name of the shop, establishment',
        'contact_person': 'Contact person',
        'email': 'Email',
        'email_suggestion': 'where the statements will arrive',
        'phone_number': 'Phone number',
        'tax_number': 'TAX number',
        'registration_number': 'Registration number',
        'iban': 'IBAN',
        'expected_traffic': 'Expected traffic',
        'annual_gross_turnover': 'Annual gross turnover',
        'gross_card_turnover': 'Gross card turnover',
        'one_time_maximum_payment': 'One time maximum payment',
        'average_card_payment': 'Average card payment',
        'minimum_transaction_fee': 'Minimum transaction fee',
        'number_of_pos_terminals': 'Number of pos terminals',
        'owner_of_space_or_tenats': 'Owner of space / tenant',
        'owner_of_space': 'Owner of space',
        'space_rental': 'Space rental',
        'wifi_or_lte': 'WiFi / LTE',
        'wifi': 'WiFi',
        'lte': 'LTE',
        'purchase_of_terminal_or_rental': 'Purchase of terminal / Terminal rental',
        'purchase_of_terminal': 'Purchase of terminal',
        'terminal_rental': 'Terminal rental',
        'personal_card_image': 'Image of personal card',
        'name_of_terminal': 'Name of terminal',
        'company_data': 'Company data',
        'turnover': 'Turnover',
        'other': 'Other',
        'start_of_billing': 'Start of billing',
        'accounting_period': 'Accounting period',
        'daily': 'Daily',
        'weekly': 'Weekly',
        '14_daily': '14 daily',
        'monthly': 'Monthly',
        'term_terminal': 'Term terminal',
        'short_term': 'Short term',
        'long_term': 'Long term'
    },
    'equipment': {
        'card_payment_equipment': 'Card payment equipment | Card payment equipments',
        'add_card_payment_equipment': 'Add card payment equipment',
        'edit_card_payment_equipment': 'Edit card payment equipment',
        'color': 'Color',
        'monthly_price': 'Monthly price',
        'one_time_price': 'One time price',
        'bought': 'Bought',
        'not_bought': 'Not bought',
        'provider_name': 'Provider name'
    }
}
